import { render, staticRenderFns } from "./AdGuardStats.vue?vue&type=template&id=03926e45&"
import script from "./AdGuardStats.vue?vue&type=script&lang=js&"
export * from "./AdGuardStats.vue?vue&type=script&lang=js&"
import style0 from "./AdGuardStats.vue?vue&type=style&index=0&id=03926e45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports